<template>
  <div>
    <div class="wrapper" v-if="!loading">
      <header-vue :show-popup="showThePopup" />
      <section-vue :birthday-needed="false" />
      <footer-vue />
    </div>
    <div class="popup" v-show="showPopup">
      <transition name="pop">
        <popup-vue v-if="showPopup" :hide="hideThePopup" />
      </transition>
    </div>
    <transition name="fade">
      <div class="loader-container" v-if="loading">
        <loader-vue />
      </div>
    </transition>
  </div>
</template>

<script>
import LoaderVue from "../../Appointment/common/Loader.vue";
import FooterVue from "../../common/Footer.vue";
import HeaderVue from "./Header.vue";
import SectionVue from "../../common/AddNew/Section.vue";
import PopupVue from "./Popup.vue";
import { authMixin } from "../../../mixins/authMixin";
import { addPersonMixin } from "../../../mixins/addPersonMixin";
import { addNewHomeMixin } from "../../../mixins/addNewHomeMixin";

export default {
  mixins: [authMixin, addNewHomeMixin, addPersonMixin],
  components: {
    HeaderVue,
    SectionVue,
    FooterVue,
    LoaderVue,
    PopupVue
  },
  destroyed() {
    this.clear();
  }
};
</script>

<style scoped>
.popup {
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
}

/* stage 2. Entered */
.pop-enter-active {
  animation: pop-in 0.2s ease-in-out forwards;
}

/* stage 3. leave */
.pop-leave-active {
  animation: pop-out 0.2s ease-in-out forwards;
}

@keyframes pop-in {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes pop-out {
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(0);
    opacity: 0;
  }
}
</style>
